export default {
  DEFAULT_I18NEXT_NAMESPACE: 'translation',
  DEFAULT_LOCALE: 'en',
  LANG_REGEX: /^(?:\/)?([a-z]{2}(?:-[a-z]{2})?)\/|^(?:\/)?([a-z]{2}(?:-[a-z]{2})?)$/,
};
